import { useDispatch, useSelector } from 'react-redux';
import { toggleProductCheck } from '../../../store/actions/admin/products';
import { EventsState } from '../../../store/types';
import { Product } from '../../../types/working-model';
import { ListGridCheckbox } from '../content/document-item';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import { useRef } from 'react';
import Slider from 'react-slick';
import {
	NextArrow,
	PrevArrow,
	settings,
} from '../create/homepage/editor/products/product';
import './product-item.scss';

interface ProductItemProps {
	product: Product;
	onEditProduct: (product: Product) => void;
}

export default function ProductItem({
	product,
	onEditProduct
}: ProductItemProps): JSX.Element {
	const {
		ProductsReducer: { checkedSet },
		ContentReducer: { view },
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();
	const titleRef = useRef<HTMLDivElement>(null);

	const isChecked = checkedSet?.has(product.product!);
	const gridView = view === 'grid';
	const listView = view === 'list';
	const uploaded = new Date(product.created_at).toLocaleDateString();
	const handleCheck = () => dispatch(toggleProductCheck(product.product!));

	const startingProduct = JSON.parse(JSON.stringify(product));
	const handleTitleClick = () => {
		if (listView) { onEditProduct(startingProduct); }
	};

	const noImage = !product.images.length;

	// const categories = "All"
	return (
		<li className={classNames('product-item', `${view}-item`)}>
			{gridView && (
				<>
					<div
						className={classNames('images-container thumbnail', {
							error: noImage,
						})}
					>
						{noImage ? (
							<Icon
								name={ICONS.IMAGE_INVERSE}
								size={64}
								color=""
							/>
						) : (
							<Slider
								prevArrow={<PrevArrow />}
								nextArrow={<NextArrow />}
								{...settings}
							>
								{product.images.map(
									(image: string, index: number) => (
										<div key={index}>
											<img
												className="thumbnail"
												src={image}
												alt=""
											/>
										</div>
									)
								)}
							</Slider>
						)}
					</div>
					<button onClick={() => onEditProduct(startingProduct)} className="no-style edit-icon">
						<Icon
							name={ICONS.EDIT}
							size={14}
							color={COLORS.WHITE}
						/>
					</button>
				</>
			)}

			<ListGridCheckbox
				id={product.product!}
				isChecked={isChecked}
				onChange={handleCheck}
				gridView={gridView}
			/>
			<p
				className="item-title grid-span"
				ref={titleRef}
				onDoubleClick={handleTitleClick}
			>
				{product.product_title.base}
			</p>

			{listView && (
				<>
					<p>{uploaded}</p>
					<hr className="hr" />
				</>
			)}
			{/* <p className="product-category">{categories}</p> */}
		</li>
	);
}
